






import Vue from 'vue'
import OrgCreate from '@/components/Orgs/OrgCreate/OrgCreate.vue'
export default Vue.extend({
  props: ['parent'],
  components: {
    OrgCreate
  }
})
